import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { SelectOption } from '../types';
import { OptionOrientation } from '../../../Shared/Enums/optionOrientation';
import { Typography } from '@mui/material';
import { GridSize } from '../../../Shared/Enums/gridSize';

interface MultiCheckboxProps {
  label: string;
  multipleSelected: string[];
  selectedOptionOrientation: OptionOrientation;
  inputOptions: SelectOption[];
  saveMultipleSelection: (values: string[]) => void;
  renderValidationErrors: () => boolean | JSX.Element;
  isHorizontalFourthOrThird: boolean;
}

export default (props: MultiCheckboxProps) => {
  const {
    label,
    multipleSelected,
    selectedOptionOrientation,
    inputOptions,
    saveMultipleSelection,
    renderValidationErrors,
    isHorizontalFourthOrThird
  } = props;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (multipleSelected.includes(event.target.name)) {
      const checkboxes = multipleSelected.filter(
        (selection) => selection != event.target.name
      );
      saveMultipleSelection(checkboxes);
    } else {
      saveMultipleSelection([...multipleSelected, event.target.name]);
    }
  };

  const isChecked = (value: string): boolean => {
    return multipleSelected.indexOf(value) >= 0;
  };

  return (
    <>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup
        row={selectedOptionOrientation == OptionOrientation.HORIZONTAL}
      >
        {inputOptions.map((option) => {
          return (
            <FormControlLabel
                  key={option.id}
                  sx={{ width: isHorizontalFourthOrThird ? '6.875rem' : '12.5rem'  } }
              label={
                <Typography >
                  {option.value}
                </Typography>
              }
              control={
                <Checkbox
                  checked={isChecked(option.value)}
                  onChange={handleCheckboxChange}
                  name={option.value}
                />
              }
            />
          );
        })}
      </FormGroup>
      {renderValidationErrors()}
    </>
  );
};
